import Datalayer from './data/Datalayer'
import AnalyticsProvider from './provider/AnalyticsProvider'
import Status from './status/Status'

interface IAnalyticsProvider {
  new (...args: unknown[]): AnalyticsProvider
}

export default class Analytics {
  providers: AnalyticsProvider[] = []

  eventsQueue = []
  isInitialized = false
  isPrepared = false

  // Initialize the providers, effectively loading and executing their scripts
  initialize = (): void => {
    for (const provider of this.providers) {
      provider.init()
    }

    this.isInitialized = true

    if (this.eventsQueue.length) {
      this.eventsQueue.forEach(({data, providers}) => {
        this.sendEvent(data, providers)
      })

      this.eventsQueue = []
    }
  }

  // Creates a list with all the providers that will be used for analytics, used before loading the providers
  prepare(providers: AnalyticsProvider[]): void {
    for (const provider of providers) {
      this.providers.push(provider)
    }

    this.isPrepared = true
  }

  /**
   * @deprecated Instead of this use sendCustomEvent (Which doesnt require to setup DLV in GTM)
   */
  async sendEvent(data: Datalayer, providers?: IAnalyticsProvider[]): Promise<Status[]> {
    // If the providers aren't initialized yet, queue these events to execute later
    if (!this.isInitialized) {
      this.eventsQueue.push({data, providers})
      return
    }

    const collection = []

    for (const provider of this.providers) {
      if (!providers) {
        if (provider.isActive) {
          collection.push(provider.sendEvent(data))
        }
      } else {
        for (const pr of providers) {
          if (pr.name === provider.constructor.name) {
            collection.push(provider.sendEvent(data))
          }
        }
      }
    }

    return Promise.all(collection)
  }

  async sendCustomEvent(
    analyticEventName: string,
    data?: Record<string, unknown>,
  ): Promise<Status[]> {
    const genericEventName = 'generic_analytics_event'
    const dlvGenericEventName = 'generic_analytics_event_data'

    const datalayerObject = new Datalayer(genericEventName, {
      [dlvGenericEventName]: JSON.stringify({analyticEventName, data}),
    })

    return this.sendEvent(datalayerObject)
  }
}
